module.exports = __webpack_public_path__ + "img/iss037e004654~large.73931b62.jpg";